export default {
  RoleList: () => import('@/views/system/role/listPage/RoleList'),
}